import React, { useEffect, useMemo, useRef } from "react";
import Highcharts from "highcharts";
import styles from "./MapPage.module.scss";
import { useGeoState } from "../../components/GeoProvider";

const BottomBarGraph = ({ seriesMale, seriesFemale,categories }) => {
  const { getGenderFilter } = useGeoState(); // this is already the value
  const gender = getGenderFilter;            // alias for clarity

  const maleContainerRef = useRef(null);     // DOM nodes
  const femaleContainerRef = useRef(null);
  const maleChartRef = useRef(null);         // Highcharts instances
  const femaleChartRef = useRef(null);

  const maleOptions = useMemo(
    () => ({
      chart: { type: "bar" },
      plotOptions: { series: { stacking: "normal" } },
      title: { text: "Male" },
      xAxis: {
        categories: categories,
        title: { text: null },
        tickLength: 0,
      },
      series:seriesMale, 
      //[
        
        // { name: "MenACWY", data: [15000, 2000, 9000, 36000, 25000, 20000], color: "orange" },
        // { name: "MenB", data: [5000, 22000, 19000, 16000, 15000, 3000], color: "green" },
        // { name: "MenABCWY", data: [10000, 12000, 9000, 6000, 50000, 1000], color: "blue" },
      //],
    }),
    [categories, seriesMale]
  );

  const femaleOptions = useMemo(
    () => ({
      chart: { type: "bar" },
      plotOptions: { series: { stacking: "normal" } },
      title: { text: "Female" },
      xAxis: {
        categories: categories,//["0–10", "11–18", "19–25", "26–35", "36–50", "51+"],
        title: { text: null },
        tickLength: 0,
      },
      series: seriesFemale, 
      // [
      //   // (Consider renaming these "Men..." series to gender-neutral names in your data)
      //   { name: "MenACWY", data: [5000, 20000, 29000, 16000, 35000, 12000], color: "orange", id: "MenACWY" },
      //   { name: "MenB", data: [5000, 22000, 19000, 16000, 15000, 3000], color: "green" },
      //   { name: "MenABCWY", data: [10000, 12000, 9000, 6000, 50000, 10000], color: "blue" },
      // ],
    }),
    [categories, seriesFemale]
  );

  useEffect(() => {
    const showMale = gender === "Male" || gender === "All";
    const showFemale = gender === "Female" || gender === "All";

    // --- MALE ---
    if (showMale && maleContainerRef.current) {
      if (!maleChartRef.current) {
        maleChartRef.current = Highcharts.chart(maleContainerRef.current, maleOptions);
      } else {
        maleChartRef.current.update(maleOptions, true, true);
      }
    } else if (maleChartRef.current) {
      maleChartRef.current.destroy();
      maleChartRef.current = null;
    }

    // --- FEMALE ---
    if (showFemale && femaleContainerRef.current) {
      if (!femaleChartRef.current) {
        femaleChartRef.current = Highcharts.chart(femaleContainerRef.current, femaleOptions);
      } else {
        femaleChartRef.current.update(femaleOptions, true, true);
      }
    } else if (femaleChartRef.current) {
      femaleChartRef.current.destroy();
      femaleChartRef.current = null;
    }

    // Cleanup on unmount
    return () => {
      if (maleChartRef.current) {
        maleChartRef.current.destroy();
        maleChartRef.current = null;
      }
      if (femaleChartRef.current) {
        femaleChartRef.current.destroy();
        femaleChartRef.current = null;
      }
    };
  }, [gender, maleOptions, femaleOptions]);

  return (
    <div
      style={{
        marginTop:"30px",
        width: "100%",
        border: "1.5px solid #cbcccd",
        borderRadius: "4px",
        //padding: "32px 24px",
      }}
    >
      <div style={{padding:"10px"}}>
        <span className={styles.captionFormat}>Age Group and Gender</span>
      </div>
      {categories.length === 0 ? (
        <div style={{ display: 'flex' ,padding:'10px',color:'#424242'}} >No data available for the selected filters</div>
      ) : (
      <div style={{ display: "flex", marginTop: "30px" }}>
        {(gender === "All" || gender === "Male") && seriesMale.length > 0 && (
          <div ref={maleContainerRef} style={{ width: "50%", height: "400px" }} />
        )}
        {(gender === "All" || gender === "Female") && seriesFemale.length > 0 && (
          <div ref={femaleContainerRef} style={{ width: "50%", height: "400px" }} />
        )}
      </div>)}
    </div>
  );
};

export default BottomBarGraph;